import { z } from 'zod';

export const PositionSchema = z.object({
  x: z.number(),
  y: z.number(),
});

export const GraphNodeSchema = z.object({
  id: z.string().min(1),
  node_type: z.string().min(1),
  position: PositionSchema,
  data: z.record(z.string(), z.unknown()),
});

export const GraphEdgeSchema = z.object({
  id: z.string().min(1),
  source: z.string().min(1),
  source_handle: z.string().min(1),
  target: z.string().min(1),
  target_handle: z.string().min(1),
});

export const ProgramGraphSchema = z.object({
  nodes: z.array(GraphNodeSchema),
  edges: z.array(GraphEdgeSchema),
});

export const ProgramSchema = z.object({
  id: z.string().min(1),
  project_id: z.string().min(1),
  name: z.string().min(1),
  graph: ProgramGraphSchema,
  archived_at_ms: z.number().int().nullable(),
  created_at_ms: z.number().int().nonnegative(),
  updated_at_ms: z.number().int().nonnegative(),
});

export const UpdateProgramSchema = z.object({
  name: z.string().min(1).optional(),
  graph: ProgramGraphSchema.optional(),
});

export type ParsedProgram = z.infer<typeof ProgramSchema>;
export type ParsedProgramGraph = z.infer<typeof ProgramGraphSchema>;
export type ParsedGraphNode = z.infer<typeof GraphNodeSchema>;
export type ParsedGraphEdge = z.infer<typeof GraphEdgeSchema>;
export type ParsedUpdateProgram = z.infer<typeof UpdateProgramSchema>;
